import React from "react";

const FeedbackIcon = ({ width, height, color }) => {
  return (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="31.5" cy="31.5" r="31.5" fill="#00008B" fillOpacity="0.1" />
      <path
        d="M44.9995 42.368C44.8555 42.368 44.7115 42.323 44.5885 42.236L38.3875 37.76H26.7115C24.0565 37.76 21.8965 35.471 21.8965 32.657V23.729C21.8965 20.915 24.0565 18.626 26.7115 18.626H40.8835C43.5385 18.626 45.6985 20.915 45.6985 23.729V41.669C45.6985 41.933 45.5515 42.173 45.3175 42.293C45.2185 42.344 45.1075 42.368 44.9995 42.368ZM26.7115 20.027C24.8275 20.027 23.2975 21.689 23.2975 23.729V32.657C23.2975 34.7 24.8305 36.359 26.7115 36.359H38.6125C38.7595 36.359 38.9035 36.407 39.0235 36.491L44.3005 40.298V23.729C44.3005 21.686 42.7675 20.027 40.8865 20.027H26.7115Z"
        fill="#FF4400"
      />
      <path
        d="M16.9988 45.3741C16.8908 45.3741 16.7798 45.3471 16.6808 45.2961C16.4468 45.1761 16.2998 44.9361 16.2998 44.6721V33.4671C16.2998 31.5651 17.7668 30.0171 19.5698 30.0171H20.3828V31.4181H19.5698C18.5378 31.4181 17.7008 32.3391 17.7008 33.4701V43.3071L20.5778 41.2281C20.6978 41.1411 20.8418 41.0961 20.9888 41.0961H28.4198C29.4518 41.0961 30.2888 40.1751 30.2888 39.0471H31.6898C31.6898 40.9491 30.2228 42.4971 28.4198 42.4971H21.2138L17.4098 45.2421C17.2868 45.3291 17.1458 45.3741 16.9988 45.3741Z"
        fill="#FF4400"
      />
      <path
        d="M27.9248 28.1659C27.9248 28.7839 28.4258 29.2849 29.0438 29.2849C29.6618 29.2849 30.1628 28.7839 30.1628 28.1659C30.1628 27.5479 29.6618 27.0469 29.0438 27.0469C28.4288 27.0439 27.9248 27.5449 27.9248 28.1659Z"
        fill="#FF4400"
      />
      <path
        d="M32.6797 28.1659C32.6797 28.7839 33.1807 29.2849 33.7987 29.2849C34.4167 29.2849 34.9177 28.7839 34.9177 28.1659C34.9177 27.5479 34.4167 27.0469 33.7987 27.0469C33.1807 27.0439 32.6797 27.5449 32.6797 28.1659Z"
        fill="#FF4400"
      />
      <path
        d="M37.4048 28.1659C37.4048 28.7839 37.9058 29.2849 38.5238 29.2849C39.1418 29.2849 39.6428 28.7839 39.6428 28.1659C39.6428 27.5479 39.1418 27.0469 38.5238 27.0469C37.9058 27.0469 37.4048 27.5449 37.4048 28.1659Z"
        fill="#FF4400"
      />
    </svg>
  );
};

export default FeedbackIcon;
